import {track} from "@vercel/analytics";
import {hasLandingAnalyticsConsent} from "./landingProductAnalytics";
import type {WorkflowEnquirySource} from "./workflowEnquiry";
export type HomeClosingEvent="homepage_closing_viewed"|"homepage_free_account_clicked"|"workflow_enquiry_opened"|"workflow_enquiry_submitted"|"workflow_enquiry_failed";
/** Only fixed dimensions; form fields and destination query strings are never accepted. */
export function trackHomeClosing(event:HomeClosingEvent,locale:string,source?:WorkflowEnquirySource):void{
 if(typeof document==="undefined"||!hasLandingAnalyticsConsent(document.cookie))return;
 try{track(event,{page:"home",section:"closing",locale:["en","es","pt-BR"].includes(locale)?locale:"en",...(source?{entry_point:source}:{})});}catch{/* Analytics must not interrupt conversion. */}
}
